window.$zoho = window.$zoho || {}
$zoho.salesiq = $zoho.salesiq || {
  widgetcode:
    'aadad72830f5ec2cece522533e9bdb070961fce03943d6720faa587dfa2a3b3e',
  values: {},
  ready: () => {
    $zoho.salesiq.floatwindow.minimize(() =>
      window.$zoho.salesiq.floatwindow.close()
    )
  }
}
var d = document
s = d.createElement('script')
s.type = 'text/javascript'
s.id = 'zsiqscript'
s.defer = true
s.src = 'https://salesiq.zoho.com/widget'
t = d.getElementsByTagName('script')[0]
t.parentNode.insertBefore(s, t)
